import api from "../../utils/API";

const getAllRegionForSelect = () => {
    return api.get(`/AllRegion/list`);
};

export {getAllRegionForSelect};